const he = {
    // ─── Auth ───────────────────────────────────────────────────────────────
    auth: {
        welcomeBack: 'ברוך הבא',
        signInTo: 'התחברו לחשבון שלכם',
        signIn: 'התחברות',
        signingIn: 'מתחברים...',
        createAccount: 'יצירת חשבון חדש',
        getStarted: 'התחילו עם RouteWise',
        createAccountBtn: 'יצירת חשבון',
        creatingAccount: 'יוצרים חשבון...',
        dontHaveAccount: 'אין לכם חשבון עדיין?',
        alreadyHaveAccount: 'כבר יש לכם חשבון?',
        email: 'כתוב דוא"ל',
        emailPlaceholder: 'אתם@חברה.com',
        password: 'סיסמה',
        passwordPlaceholder: 'הסיסמה שלכם',
        passwordHint: 'לפחות 6 תווים',
        confirmPassword: 'אישור סיסמה',
        confirmPasswordPlaceholder: 'אשרו את הסיסמה שלכם',
        yourName: 'השם שלכם',
        namePlaceholder: 'יוহנן לוי',
        companyName: 'שם החברה',
        companyPlaceholderHvac: 'שירותי מיזוג אוויר ABC',
        companyPlaceholderConstruction: 'חברת בנייה ABC',
        phoneNumber: 'מספר טלפון',
        phonePlaceholder: '5012345678',
        fullNumber: 'מספר מלא:',
        industryQuestion: 'לאיזה תחום אתם שיכים?',
        hvacDesc: 'חימום, קירור ואוויר',
        constructionDesc: 'בנייה ותשתיות',
        passwordsNoMatch: 'הסיסמות לא תואמות',
        passwordTooShort: 'הסיסמה חייבת להיות לפחות 6 תווים',
        selectIndustry: 'בבקשה בחרו תחום',
    },

    // ─── Dashboard ──────────────────────────────────────────────────────────
    dashboard: {
        dispatchNeedsTechnician: '{{count}} עבודות ממתינות לשיבוץ טכנאי',
        dispatchWaiting: '{{count}} ממתינות לאישור הטכנאי',
        dispatchCta: 'שבצו עכשיו',
        title: 'לוח בקרה',
        welcome: 'שלום,',
        companyCodeLabel: 'קוד החברה',
        companyCodeDesc: 'שיתפו את הקוד הזה עם ה{{workers}} שלכם כדי שהם יוכלו להצטרף ממכשיר הטלפון',
        copy: 'כפיפה',
        copied: 'נעתיק!',

        // HVAC stats
        totalJobs: 'סה"כ עבודות',
        scheduledToday: 'מתוכנן היום',
        customers: 'לקוחות',

        // Construction stats
        activeProjects: 'פרויקטים פעילים',
        scheduled: 'מתוכננים',
        completed: 'הושלמו',
        thisQuarter: 'רבעון זה',
        totalProjects: 'סה"כ פרויקטים',
        allTime: 'בסה"כ',

        // Panels
        todaySchedule: 'לוח היום',
        noJobsToday: 'אין עבודות מתוכננות היום',
        scheduleAJob: 'תכנון עבודה',
        viewAll: '← הציגו הכל',

        activeWorkers: '{{workers}} פעילים',
        noWorkersYet: 'עדיין אין {{workers}}',

        // Quick Actions
        quickActions: 'פעולות מהירות',
        addCustomer: 'הוספת לקוח',
        addCustomerSub: 'הוספת לקוח חדש',
        createA: 'יצירת',

        newServiceCall: 'קריאת שירות חדשה',
        newServiceCallSub: 'יצירת קריאת שירות משיחת טלפון נכנסת',

        // Worker statuses
        available: 'זמין',
        onsite: 'בשטח',
        offline: 'לא מחובר',

        // Revenue board
        revenue: {
            title: 'סקירת הכנסות',
            totalRevenue: 'סה"כ הכנסות',
            thisMonth: 'החודש',
            thisWeek: 'השבוע',
            avgJobValue: 'ממוצע לעבודה',
            monthlyTrend: 'מגמה חודשית',
            noData: 'אין נתוני הכנסות עדיין',
            currency: '₪',
        },
    },

    // ─── Industry-specific labels ───────────────────────────────────────────
    industry: {
        hvac: {
            workers: 'טכנאים',
            workerSingle: 'טכנאי',
            jobs: 'עבודות',
            jobSingle: 'עבודה',
            newJob: 'עבודה חדשה',
            addWorker: 'הוספת טכנאי',
            registerWorker: 'רישום טכנאי חדש',
        },
        construction: {
            workers: 'עובדים',
            workerSingle: 'עובד',
            jobs: 'פרויקטים',
            jobSingle: 'פרויקט',
            newJob: 'פרויקט חדש',
            addWorker: 'הוספת עובד',
            registerWorker: 'רישום עובד חדש',
        },
    },

    // ─── Navigation ─────────────────────────────────────────────────────────
    nav: {
        dashboard: 'לוח בקרה',
        projects: 'פרויקטים',
        jobs: 'עבודות',
        workers: 'עובדים',
        technicians: 'טכנאים',
        customers: 'לקוחות',
        routes: 'מסלולים',
        leads: 'לידים',
        schedule: 'לוח זמנים',
        reports: 'דוחים',
        settings: 'הגדרות',
        help: 'עזרה',
        logout: 'התנתקות',
    },

    // ─── Customers ──────────────────────────────────────────────────────────
    customers: {
        title: 'לקוחות',
        addCustomer: '+ הוספת לקוח',
        searchPlaceholder: 'חיפוש לקוחות...',
        noCustomers: 'לא נמצאו לקוחות. הוספו את הלקוח הראשון שלכם!',
        loading: 'טוען לקוחות...',
        deleteConfirm: 'בהককם אתם רוצים למחק את הלקוח הזה?',
        failedCreate: 'נכשל יצירת לקוח',
        failedUpdate: 'נכשל עדכון לקוח',
        failedDelete: 'נכשל מחיקת לקוח',
        editCustomer: 'עריכת לקוח',
        addNewCustomer: 'הוספת לקוח חדש',
        name: 'שם *',
        phone: 'טלפון *',
        email: 'דוא"ל',
        address: 'כתובת *',
        addressPlaceholder: '123 רחוב הראשון, תל אביב',
        notes: 'הערות',
        cancel: 'ביטול',
        update: 'עדכון',
        add: 'הוספת',
        customer: 'לקוח',
    },

    // ─── Workers ────────────────────────────────────────────────────────────
    workers: {
        title: 'עובדים',
        addWorker: '+ הוספת עובד',
        showActiveOnly: 'הציגו פעילים בלבד',
        noWorkers: 'לא נמצאו עובדים. הוספו את העובד הראשון שלכם!',
        loading: 'טוען עובדים...',
        deleteConfirm: 'בהציבו אתם רוצים למחק את העובד הזה?',
        failedCreate: 'נכשל יצירת עובד',
        failedUpdate: 'נכשל עדכון עובד',
        failedDelete: 'נכשל מחיקת עובד',
        active: 'פעיל',
        inactive: 'לא פעיל',
        editWorker: 'עריכת עובד',
        addNewWorker: 'הוספת עובד חדש',
        name: 'שם *',
        phone: 'טלפון *',
        email: 'דוא"ל',
        role: 'תפקיד',
        selectRole: 'בחרו תפקיד',
        roleWorker: 'עובד',
        roleForeman: 'מנהל עבודה',
        roleSupervisor: 'מפקד',
        roleTechnician: 'טכנאי',
        activeToggle: 'פעיל',
        cancel: 'ביטול',
        update: 'עדכון',
        add: 'הוספת',
        worker: 'עובד',
        fullNumber: 'מספר מלא:',
        homeAddress: 'כתובת בית',
        homeAddressPlaceholder: 'הזן כתובת בית של העובד',
        homeAddressHelp: 'משמש לאופטימיזציה של מסלולים',
    },

    // ─── Jobs ───────────────────────────────────────────────────────────────
    jobs: {
        title: 'עבודות',
        createJob: '+ יצירת עבודה',
        filterAll: 'הכל',
        noJobs: 'לא נמצאו עבודות. יצרו את העבודה הראשונה שלכם!',
        loading: 'טוען עבודות...',
        deleteConfirm: 'בהציבו אתם רוצים למחק את העבודה הזאת?',
        failedCreate: 'נכשל יצירת עבודה',
        failedUpdate: 'נכשל עדכון עבודה',
        failedDelete: 'נכשל מחיקת עבודה',
        failedAssign: 'נכשל הקצאת טכנאי',
        failedStatus: 'נכשל עדכון הסטטוס',
        scheduled: 'מתוכנן:',
        unassigned: 'לא הוקצא',
        startJob: 'התחילו עבודה',
        complete: 'השלמה',
        edit: 'עריכה',
        delete: 'מחיקה',
        editJob: 'עריכת עבודה',
        createNewJob: 'יצירת עבודה חדשה',
        customerLabel: 'לקוח *',
        selectCustomer: 'בחרו לקוח',
        technicianLabel: 'טכנאי (אופציונלי)',
        jobTitle: 'כותרת העבודה *',
        jobTitlePlaceholder: 'תיקון מיזוג אוויר',
        description: 'תיאור',
        descriptionPlaceholder: 'המכשיר לא מקרר כראוי...',
        scheduledDateTime: 'תאריך ושעה מתוכננים *',
        duration: 'משך הזמן (דקות)',
        price: 'מחיר (₪)',
        cancel: 'ביטול',
        updateJob: 'עדכון עבודה',
        createJobBtn: 'יצירת עבודה',
        filterUnassigned: 'לא משובצות',
        needsTechnician: 'צריך טכנאי',
        waitingFor: 'ממתין לאישור של {{name}}',
        accepted: 'אושר על ידי {{name}}',
        declinedBy: 'נדחה על ידי {{name}}',
        declineReason: 'סיבה: {{reason}}',
        fromBid: 'מהצעת מחיר',
    },

    // ─── Service Call ─────────────────────────────────────────────────────────
    serviceCall: {
        title: 'קריאת שירות חדשה',
        customerInfo: 'פרטי לקוח',
        jobDetails: 'פרטי עבודה',
        customerName: 'שם הלקוח *',
        customerNamePlaceholder: 'יוהנן לוי',
        phone: 'טלפון *',
        phonePlaceholder: '050-123-4567',
        email: 'דוא"ל *',
        emailPlaceholder: 'customer@email.com',
        address: 'כתובת',
        addressPlaceholder: '123 רחוב הראשון, תל אביב',
        jobTitle: 'כותרת העבודה *',
        jobTitlePlaceholder: 'תיקון מיזוג אוויר',
        description: 'תיאור',
        descriptionPlaceholder: 'המכשיר לא מקרר כראוי...',
        scheduledDate: 'תאריך ושעה מתוכננים *',
        priority: 'עדיפות',
        priorityLow: 'נמוכה',
        priorityMedium: 'בינונית',
        priorityHigh: 'גבוהה',
        technician: 'טכנאי',
        selectTechnician: 'בחירת טכנאי (אופציונלי)',
        cancel: 'ביטול',
        submit: 'יצירת קריאת שירות',
        submitting: 'יוצרים...',
        successTitle: 'קריאת שירות נוצרה!',
        successMessage: 'עבודה מס\' {{jobId}} תוכננה',
        customerNew: 'לקוח חדש נוצר',
        customerExisting: 'שויך ללקוח קיים',
        done: 'סיום',
        error: 'נכשל ביצירת קריאת שירות. אנא נסו שנית.',
    },

    // ─── Find Service (customer discovery) ──────────────────────────────────
    findService: {
        title: 'מצאו ספק שירות באזורכם',
        subtitle: 'הזינו את כתובתכם וזמן מועדף לקבלת רשימת ספקים זמינים',
        yourAddress: 'הכתובת שלכם',
        addressPlaceholder: 'הזינו את כתובתכם',
        preferredTime: 'זמן מועדף לביקור',
        searchBtn: 'חיפוש ספקים',
        searching: 'מחפש...',
        noResults: 'לא נמצאו ספקים באזורכם. נסו לשנות את הכתובת.',
        away: 'ק"מ ממכם',
        visitFee: 'דמי ביקור',
        repairEstimate: 'הערכת תיקון',
        call: 'התקשרו',
        forProviders: 'ספקי שירות? התחברו',
        problemLabel: 'תארו את הבעיה',
        problemPlaceholder: 'למשל: המזגן לא מקרר, יש רעש חריג, נזל מים...',
        badge1: 'ללא עמלות',
        badge2: 'מחירים שקופים',
        badge3: 'טכנאים מוסמכים',
        resultsFound: 'ספקים נמצאו',
        serviceTypeLabel: 'סוג השירות',
        hvac: 'מיזוג אוויר',
        plumbing: 'אינסטלציה',
        electrical: 'חשמלאי',
        requestService: 'בקשת שירות',
        yourName: 'השם שלכם',
        namePlaceholder: 'יוהנן לוי',
        yourPhone: 'הטלפון שלכם',
        sendRequest: 'שליחת בקשה',
        sending: 'שולח...',
        requestSent: 'הבקשה נשלחה!',
        requestSentSub: 'ייצור איתכם קשר בקרוב.',
        requestError: 'שגיאה בשליחת הבקשה. נסו שנית.',
        cancelRequest: 'ביטול',
        close: 'סגירה',
        postJob: 'פרסמו את העבודה שלכם',
        postJobSub: 'נשלח אותה לספקים באזור כדי שיוכלו להציע הצעת מחיר',
        postJobBtn: 'פרסום עבודה — קבלת הצעות',
        previewBtn: 'תצוגה מקדימה של ספקים באזור',
    },

    // ─── Service Request Tracking (customer bid tracking page) ──────────────
    requestTracking: {
        title: 'הבקשה שלכם',
        loading: 'טוען את הבקשה שלכם...',
        notFound: 'הבקשה לא נמצאה.',
        statusOpen: 'ממתין להצעות',
        statusAwarded: 'ספק נבחר',
        statusCancelled: 'בוטל',
        noBidsYet: 'עדיין אין הצעות — ספקים באזור קיבלו הודעה.',
        bidsHeading: 'הצעות שהתקבלו',
        award: 'בחרו ספק זה',
        awarding: 'בוחר...',
        awardedTo: 'בחרתם ב-{{name}} עבור העבודה הזו.',
        eta: 'זמן הגעה',
        minutes: 'דק׳',
        refresh: 'רענון',
    },

    // ─── Leads (org-side, smart dispatching) ─────────────────────────────────
    leads: {
        title: 'לידים',
        subtitle: 'עבודות באזור השירות שלכם',
        empty: 'אין כרגע לידים פתוחים באזור שלכם.',
        yourBid: 'ההצעה שלכם',
        priceLabel: 'המחיר שלכם (₪)',
        etaLabel: 'זמן הגעה (דקות)',
        messageLabel: 'הודעה ללקוח',
        submitBid: 'שליחת הצעה',
        updateBid: 'עדכון הצעה',
        submitting: 'שולח...',
        bidSubmitted: 'ההצעה נשלחה',
        bidAwarded: 'זכיתם בליד הזה',
        bidRejected: 'הליד הוענק לספק אחר',
        bidError: 'שגיאה בשליחת ההצעה. נסו שנית.',
    },

    // ─── Organization Settings ───────────────────────────────────────────────
    settings: {
        title: 'הגדרות',
        saving: 'שומר...',
        saved: 'נשמר!',
        saveError: 'שגיאה בשמירה, נסו שנית',
        serviceArea: {
            title: 'אזור שירות',
            current: 'כתובת נוכחית',
            address: 'כתובת מרכז הפעילות',
            addressPlaceholder: 'הזינו את כתובת העסק',
            radius: 'רדיוס שירות',
            save: 'שמירת אזור שירות',
        },
        pricing: {
            title: 'מחירים',
            visitFee: 'דמי ביקור',
            repairMin: 'הערכת תיקון מינימום',
            repairMax: 'הערכת תיקון מקסימום',
            save: 'שמירת מחירים',
        },
    },

    // ─── Footer ─────────────────────────────────────────────────────────────
    footer: {
        copyright: '© 2026 RouteWise. תוכנה לניהול שירותי שדה.',
    },

    // ─── Status badges ──────────────────────────────────────────────────────
    status: {
        scheduled: 'מתוכנן',
        inProgress: 'בתהליכים',
        completed: 'הושלם',
        cancelled: 'בוטל',
    },
};

export default he;
